import { Component, OnInit, ViewEncapsulation} from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_LANGUAGE_ID, HeaderStyle, chineseLanguageCodes, componentName } from 'src/app/shared/constants/commonenums';
import { FieldConfig } from 'src/app/shared/dynamicform/models/common-models';
import { Language, LanguageFileName } from 'src/app/shared/Models/WidgetSettingsModels';
import { LocalizeService } from 'src/app/shared/services/localize.service';
import { LayoutService } from '../layout.service';
import { map } from 'rxjs/operators';
import { GuestService } from 'src/app/shared/services/guest.service';
import moment, { lang } from 'moment';
import { environment } from 'src/environments/environment';
import _ from 'lodash';

@Component({
  selector: 'app-header',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  languageConfig:FieldConfig[];
  languageOptions=[];
  headerStyle = HeaderStyle;
  restaurantId = null;
  hideLanguageOption = false;
  initialLanguageChange = true;
  IsMultiLanguageSelectionEnabled: boolean;
  componentName = componentName
  constructor(private translateService: TranslateService,public ls:LayoutService, private localizeService: LocalizeService,
    private route: ActivatedRoute,public gs:GuestService,private router: Router){

  }

  ngOnInit(){
    this.restaurantId = this.ls.restaurantWidgetSettings$.value.RestaurantId;
    this.hideLanguageOption = environment?.restaurantIdToHideLanguages?.some((item: number) => item === this.restaurantId);
    this.gs.checkLanguageAvailabilityOption();
    this.generateLanguageOptions();
    this.languageConfig = [
        {
          type: 'select',
          name: 'sortBy',
          placeholder: '',
          options: this.languageOptions,
          value:this.gs.selectedLanguageId ? this.gs.selectedLanguageId : this.languageOptions[0].id,
          showErrorText: true,
          isTranslate: true,
          appearance: false,
          cellClick: this.setDefaultLanguage.bind(this),
          class: 'header__language',
          isFormArray: false
        }
    ];
    const url = new URL(window.location.href);
    let language = this.route.snapshot.params['language'] || url.searchParams.get('language');
    if(language){
      this.gs.selectedLanguageId = Number(LanguageFileName[language]);
      this.languageConfig[0].value = this.gs.selectedLanguageId;
      this.languageConfig = [...this.languageConfig];
    }
    if(!language){
      const url = new URL(window.location.href);
      language = this.route.snapshot.queryParams['language'];
      language = language?.toLowerCase();
      this.languageConfig[0].value = language ? LanguageFileName[language] : sessionStorage.getItem('languageId') ? Number(sessionStorage.getItem('languageId')): this.languageOptions[0].id 
      this.setLanguage({value: sessionStorage.getItem('languageId') ? sessionStorage.getItem('languageId') : this.languageOptions[0].id},language)
    }
    //this.generateOptions();
  }

  showRestrictedLanguage() {
      return (environment.restaurantIdToHideLanguages?.filter(restaurantId => restaurantId == this.ls.restaurantWidgetSettings$.value.RestaurantId)?.length > 0);
    }

setDefaultLanguage(event){
  if(this.initialLanguageChange){
    sessionStorage.setItem('languageId',event.value)
    this.gs.selectedLanguageId = Number(event.value);
    this.initialLanguageChange = false;
    this.gs.loadLanguageData(LanguageFileName[event.value]);
  }
  this.setLanguage(event)
}

    /* setting language on change of drop down */
    setLanguage(event,language?) {
    //  moment.locale(this.gs.findLocale(event.value));
    if(language && this.gs.availableLanguages){
      event.value = this.gs.availableLanguages.find(lng => lng.Name.toLowerCase() == language)?.Id || DEFAULT_LANGUAGE_ID
    }
      this.gs.selectedLanguageId = event.value;
      sessionStorage.setItem('languageId',event.value)
      let selectedLanguage= LanguageFileName[event.value];
      this.localizeService.setLanguage(selectedLanguage, this.ls.restaurantWidgetSettings$.value.PropertyType.toLowerCase());
      this.gs.languageFileChanges.next(LanguageFileName[event.value]);
  }

    generateLanguageOptions(){
      this.ls.restaurantWidgetSettings$.subscribe((data : any) => {
        this.IsMultiLanguageSelectionEnabled = data.IsMultiLanguageSelectionEnabled ;

        if(data.Languages?.length)
          if(this.showRestrictedLanguage()){
            this.gs.availableLanguages = data.Languages;
            let languages = _.cloneDeep(data.Languages);
            languages = languages.filter(lang => lang.Code != 'fr' && lang.Code != 'ko' && lang.Code != 'ja'); 
            this.languageOptions  = languages.map(language =>  { return { id: language.Id , value: language.DisplayName}});
          }
          else{
        this.gs.availableLanguages = data.Languages;
          this.languageOptions  = data.Languages.map(language =>  { return { id: language.Id , value: language.DisplayName}});
          }
      })
    }




}
